export default "__VITE_ASSET__DfHXnOEu__"